import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/rem.js';
import echarts from 'echarts'

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.use(Vant);
Vue.config.productionTip = false;

Vue.prototype.$echarts = echarts
// router.beforeEach((to, from, next) => {
//   /*路由发生改变修改页面的title */
//   // if(to.meta.title) {
//   //   document.title = to.meta.title
//   // }
//   if(to.path=='/login'){
//     next()
//   }else{
//     if( localStorage.getItem('userInfo')){
//       next();
//     }else{
//       router.push('/login')
//     }
//   }
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
